import { AfterViewInit, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PreloaderService } from '@core';
import { UserService } from '@core/bootstrap/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  privacyLink = '/privacy';
  privacy = false;
  public constructor(
    private preloader: PreloaderService,
    private userService: UserService,
    private router: Router
  ) {
    if (
      !window.location.href.includes('authentication/callback') &&
      window.location.href.includes('/dashboard')
    ) {
      sessionStorage.setItem(
        'route',
        window.location.href.slice(window.location.href.indexOf('/dashboard'))
      );
    }

    this.userService.activeAccountChange$.subscribe({
      next: user => {
        if(user.idTokenClaims?.ciamId){
          this.privacyLink =
            'https://datenschutzhinweise.telekom.de/default.aspx?q=cf47a4d2-9831-46bd-9097-a2ea35014a31&preview=yes&lang=de';
        }
      }
    })

    this.router.events.subscribe({
      next: res => {
        if(res instanceof NavigationEnd){
          this.privacy = res.url.includes('/privacy')
        }
      }
    })
  }

  public ngAfterViewInit() {
    this.preloader.hide();
  }
}
